import { receiveJobEvent, resolveJob } from "./slices/jobs-slice";

export const jobMiddleware = store => next => action => {
  const result = next(action);

  if (action.type === receiveJobEvent.type) {
    const { event } = action.payload;
    const id = event?.executionId;
    if (!id) return result;
    const failed = event?.status === 'FAILED';
    store.dispatch(resolveJob({ id, status: failed ? 'failed' : 'done' }));
  }

  return result;
};

export default jobMiddleware;
